module.exports = __webpack_public_path__ + "img/kiwoom_main_left3.4142874a.png";